import './App.css';
import AppStyles from 'src/AppStyles';
import Main from "src/pages/main/Main";
import {createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider} from "react-router-dom";
import PrivacyPolicy from "src/pages/privacy-policy/PrivacyPolicy";
import Layout from "src/components/layouts/Layout";
import Terms from "src/pages/terms/Terms";

function getRoutes() {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<Layout />} >
          <Route path="/" element={<Main />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>,
    ),
  );
}

function App() {
  return (
    <AppStyles>
      <RouterProvider router={getRoutes()} />
    </AppStyles>
  );
}

export default App;
